import Vue from 'vue'
import Vuex from 'vuex'
// import axios from 'axios' // remove comment if yu needed
import Crud from '../crud'
const model = (payload) => ({
  // columns
  id: payload.id,
  name: payload.name
})
var crud = new Crud('ProductionStatuses', model)

Vue.use(Vuex)

const state = {
  ...crud.state,
  productionStatuses: []
}

const mutations = {
  ...crud.mutations
}

const actions = {
  ...crud.actions
}

const getters = {
  ...crud.getters,
  productionStatuses: state => state.productionStatuses
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
